/* 孫吳傳・第 9 章：丹徒（200 年）
 * 丹徒附近的獵場：一大片草地與疏林，東邊是江邊的蘆葦叢（許貢的門客躲在這裡）。 */
export const REEDS = [5600, 2600];
export default {
  id: 'dantu', name: '丹徒', W: 7200, H: 5000, seed: 200,
  bases: [[900, 2500], [6800, 2500]],
  roads: [{ pts: [[900, 2500], [2400, 2400], [3800, 2600], [5000, 2500]], w: 120 }],
  rocks: [[2600, 1200, 380, 200], [3000, 3900, 420, 200], [4700, 1300, 300, 160]],
  woods: 0.3,
  sight: 0.85,
  clearings: [[3000, 2500, 1100], [4600, 3000, 600]],
  tents: [{ x: 900, y: 2500, n: 4, r: 300, col: '#b8433a', flag: '孫' }],
  fields: [[2000, 3500, 600, 280], [4200, 1900, 500, 260, '#86803f']],
  grass: [[REEDS[0], REEDS[1], 420, 200], [5800, 2000, 260, 120], [5900, 3200, 280, 120], [3600, 1500, 220, 100], [2200, 3000, 220, 100]],
};
